import { Component, OnInit, Input } from '@angular/core';

type spinnerType = 'fullscreen' | 'normal' | 'preview' | 'loading-spinner';
@Component({
  selector: 'app-smash-loading-spinner',
  templateUrl: './smash-loading-spinner.component.html',
  styleUrls: ['./smash-loading-spinner.component.scss']
})
export class SmashLoadingSpinnerComponent implements OnInit {

  defaultType: spinnerType = "normal";

  @Input() type: spinnerType = this.defaultType;

  loaderState = 'state1';

  constructor() { }

  ngOnInit() { }

}
